"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../constants/icons");
var molecules_1 = require("../../molecules");
var CustomDatePickerHeader = function (_a) {
    var monthDate = _a.monthDate, customHeaderCount = _a.customHeaderCount, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth;
    return (react_1.default.createElement("div", { className: 'tw-bg-white -tw-mt-2 tw-flex tw-justify-between tw-px-2 f-14-300 tw-items-center tw-py-2' },
        react_1.default.createElement("button", { "aria-label": 'Previous Month', className: 'hover:tw-bg-GRAY_5 tw-rounded-full tw-h-6 tw-w-6 tw-px-1 hover:tw-text-white', style: customHeaderCount === 1 ? { visibility: 'hidden' } : {}, onClick: decreaseMonth },
            react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-left', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, width: 16, height: 16 })),
        react_1.default.createElement("span", { className: '' }, monthDate.toLocaleString('en-US', {
            month: 'long',
            year: 'numeric',
        })),
        react_1.default.createElement("button", { "aria-label": 'Previous Month', className: 'hover:tw-bg-GRAY_5 tw-rounded-full tw-h-6 tw-w-6 tw-px-1 hover:tw-text-white', style: customHeaderCount === 1 ? { visibility: 'hidden' } : {}, onClick: increaseMonth },
            react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-right', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, width: 16, height: 16 }))));
};
exports.default = CustomDatePickerHeader;
